(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import { createGlobalStyle } from 'styled-components';

var _default = createGlobalStyle(["body{font-family:", ";}html{box-sizing:border-box;}*,*:before,*:after{box-sizing:inherit;}h1,h2,h3,h4,h5,h6,h7,p{margin:0;padding:0;}h2,h3,h4,h5,h6,h7{font-weight:200;color:", ";}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active{-webkit-transition-delay:999999s;-webkit-transition:color 999999s ease-out,background-color 999999s ease-out;}"], function (props) {
  return props.theme.styles.fonts.primary;
}, function (props) {
  return props.theme.styles.colors.headings;
});

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/styles/Global.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();